export const throttle = (fn) => {
    let frame = null;
    let stored = null;
    const throttled = (arg) => {
        stored = arg;
        if (!frame) {
            frame = window.requestAnimationFrame(() => {
                fn(stored);
                frame = null;
            });
        }
    };
    return throttled;
};
const hue = throttle((kek) => ('hue'));
